import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { DatepickerComponent } from '../datepicker-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors, Form } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-healthlog',
  templateUrl: './healthlog.component.html',
  styleUrls: ['./healthlog.component.css']
})
export class HealthlogComponent implements OnInit {
  healthlogForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter ();
  @ViewChild(DatepickerComponent) datepicker: DatepickerComponent;
  failedMessage: string;
  submitted: boolean;
  cookie: any;
  healthLogSaved: boolean;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  ngOnInit(): void {
    let regexPatterns = {
      num: "^[0-9]+$",
   };
    this.healthlogForm  =  this.formBuilder.group({
      waist: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      glucose: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      bloodhigh: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      bloodlow: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      hdl: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      ldl: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      a1c: ['', [Validators.required, Validators.pattern(regexPatterns.num)]],
      healthDate: ['', [Validators.required]],
    });
  }
  get fmBuilder() { return this.healthlogForm.controls; }

  getFormControl(name:any) {
    return this.healthlogForm.get(name);
  }

  constructor(
    private router: Router,
    private _bkoffService: BackOffServiceService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private breakpointObserver: BreakpointObserver

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  closeHealthLog() {
    this.doneSubmiting.emit("saved");
    this.healthLogSaved = true;
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.healthlogForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.healthlogForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }


  submitClick() {
    var healthLogData = new LogsData();
    healthLogData.waist = Number(this.healthlogForm.get(['waist']).value);
    healthLogData.glucose = Number(this.healthlogForm.get(['glucose']).value)
    healthLogData.bloodhigh = Number(this.healthlogForm.get(['bloodhigh']).value)
    healthLogData.bloodlow = Number(this.healthlogForm.get(['bloodlow']).value)
    healthLogData.hdl = Number(this.healthlogForm.get(['hdl']).value)
    healthLogData.ldl = Number(this.healthlogForm.get(['ldl']).value);
    healthLogData.a1c = Number(this.healthlogForm.get(['a1c']).value);
    healthLogData.healthDate = this.datepicker.dateEntry.toString();


    this._bkoffService.createHealthLog(healthLogData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.healthLogSaved = true;
      this.healthlogForm.reset();

     console.log("successfully saved health log ")
     const modalRef = this.modalService.open(NgbdModalContent);
     modalRef.componentInstance.title = 'Success';
     modalRef.componentInstance.name = 'Health log has been saved';

    }).catch(()=>{
     this.failedMessage  = "Error saving health logs "
     this.healthLogSaved = false
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });
    }
    

   sendUserFeedback(){
    
      const modalRef = this.modalService.open(NgbdModalContent);
      if (!this.healthLogSaved){
        modalRef.componentInstance.name = 'Error saving data , please try again';
      }
     
    }

}